import { api } from "../lib/api";

export async function importExcel(file) {
  const form = new FormData();
  form.append("file", file);
  return api.post("/api/excel/import", form);
}

export async function downloadTable(table) {
  const { blob, filename } = await api.blob(
    `/api/excel/export/${encodeURIComponent(table)}`
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
